import * as React from 'react';

function SvgUsers(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.93 18.99" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path
        d="M16.72 16.56c-.76-.82-3.85-1.59-5.42-2.42a3 3 0 01-1.57-2.66 2.15 2.15 0 01.64-1.31 4 4 0 00.62-1.24 1.51 1.51 0 00.87-1.54 2.1 2.1 0 00-.29-1.24c.06-.53.12-1.12.18-1.65A4.49 4.49 0 007.4 0a4.53 4.53 0 00-4.41 4.5c.06.59.12 1.12.18 1.65a2.1 2.1 0 00-.29 1.24 1.51 1.51 0 00.91 1.54 4 4 0 00.64 1.24 2.15 2.15 0 01.64 1.31 3.06 3.06 0 01-1.51 2.66c-.94.47-2.39.95-3.56 1.42v3.37h17.47a3.39 3.39 0 00-.75-2.37z"
        fill="#1d1d1b"
      />
      <path
        d="M23.99 16.27c-1-.42-2.27-.83-3-1.18a2.53 2.53 0 01-1.28-2.19 1.87 1.87 0 01.52-1.07 3.22 3.22 0 00.53-1 1.2 1.2 0 00.75-1.25 1.45 1.45 0 00-.23-1 10.56 10.56 0 00.12-1.36 3.84 3.84 0 00-3.55-3.79 3.83 3.83 0 00-3.61 3.79c.05.47.05.94.11 1.36a1.5 1.5 0 00-.23 1 1.21 1.21 0 00.76 1.25 4.82 4.82 0 00.52 1 1.87 1.87 0 01.52 1.07 2.42 2.42 0 01-.52 1.53 6.34 6.34 0 012.59 1.66 4.88 4.88 0 01.93 2.9h5.07v-2.72z"
        fill="#1d1d1b"
      />
    </svg>
  );
}

const MemoSvgUsers = React.memo(SvgUsers);
export default MemoSvgUsers;
